module.exports = __webpack_public_path__ + "assets/img/python.adfefe0c.svg";